// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!./media-query.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("3eb2e9cd", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/media-query.css
// module id = 534
// module chunks = 309